import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useRouteMatch } from 'react-router-dom';
import { getInt } from '../../../../utils/functions';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_AUTOMATIC_STATE_TRANSITIONS } from 'constants/rightsCodes';

import AutomaticStateTransitionContainer from './AutomaticStateTransitionContainer';
import HeaderLinks from './header/HeaderLinks';
import HeaderTitle from './header/HeaderTitle';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const Route = ({ getElemByAreaKey }) => {
  const match = useRouteMatch();
  const automaticStateTransitionId = getInt(match.params.automaticStateTransitionId);
  const historyContext = useHistoryWithContext();

  const onClickClose = () => {
    historyContext.push(`/automaticStateTransitions`);
  };

  const onRedirect = useCallback(
    automaticStateTransitionId => {
      historyContext.push(`/automaticStateTransitions/${automaticStateTransitionId}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <HeaderTitle />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_AUTOMATIC_STATE_TRANSITIONS}>
        <AutomaticStateTransitionContainer automaticStateTransitionId={automaticStateTransitionId} onRedirect={onRedirect} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
